<gt-main-nav>
  <gt-rate-limit-banner></gt-rate-limit-banner>
  <router-outlet></router-outlet>
</gt-main-nav>
